import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import { withLoggedOut } from '../../utils/hoc/hoc';

const ForgotPasswordPage = () => <ForgotPassword />;

export default withLoggedOut(ForgotPasswordPage);
